import { IsBoolean, IsEnum, IsNumber, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export enum OrderItemStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}

export class OrderItemVm extends EntityVm {
  @IsString()
  orderId: string;

  @IsString()
  warehouseId: string;

  @IsString()
  productId: string;

  @IsString()
  productName: string;

  @IsString()
  productSku: string;

  @IsString()
  productOptionalCode: string;

  @IsNumber()
  packageSize: number;

  @IsBoolean()
  isContainer: boolean;

  @IsBoolean()
  usesPackage: boolean;

  @IsBoolean()
  usesBatch: boolean;

  @IsBoolean()
  usesSerialNumber: boolean;

  @IsBoolean()
  usesContainer: boolean;

  @IsBoolean()
  usesIntegerQuantity: boolean;

  @IsBoolean()
  needsPreparation: boolean;

  @IsNumber()
  quantity: number;

  @IsNumber()
  quantityPicked: number;

  @IsNumber()
  quantitySatisfied: number;

  @IsBoolean()
  isPending: boolean;
}
